import { DATA_SOURCES_GET } from '../../constants/constants';
import * as Api from '../../api/entities/dataSourceApi';

import { createApiCallAction } from '../apiCallAction';

const getAllDataSourcesAction = createApiCallAction(DATA_SOURCES_GET, Api.getAllDataSources, {
  transformPayload: (body, [lang]) => ({ lang, all: body.payload })
});
export const getAllDataSources = lang => getAllDataSourcesAction(lang);
